export const styles = {
  container: {
    width: '100%',
    height: '100vh',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  authContainer: {
    width: '100%',
    zIndex: 2,
    backdropFilter: 'blur(34px)',
    boxShadow: '-2px 0px 34px 0px #8B36164D',
    borderRadius: '10px',
  },
};
